import { withInstall } from '@vuemap/vue-amap-util'
import Satellite from './Satellite.vue'

export const ElAmapLayerSatellite = withInstall(Satellite)
export default ElAmapLayerSatellite
